import MemberRequest from "../../../../Controllers/MemberRequest";
import {   digitsArToEn,   digitsFaToEn   } from "@persian-tools/persian-tools";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("mosavabatInsert")) {
    if (data.mosavabatInsert === true || data.mosavabatInsert === "true") res = true;
  }
  return res;
}

const sendInsertApi = async function (number,title ,description,txt, filesTmpId, pageAlerts,formAlerts) {
  let res=false;
  let req=new MemberRequest();
  req._formAlerts=formAlerts;
  req._pageAlerts=pageAlerts;

  if(!Boolean(number)) number="0";
  number=digitsArToEn(digitsFaToEn(number));

  req.query=`{mosavabatInsert(number:${number},title:"${title}", filesTmpId:[${filesTmpId.toString()}],description:"""${description}""",txt:"""${txt}""")}`;
  res = await req.send(getResult);
  return res;
};

export default async function mosavabatInsertApi(number,title ,description,txt, filesTmpId, pageAlerts,formAlerts) {
  return await sendInsertApi(number,title ,description,txt, filesTmpId, pageAlerts,formAlerts);
}
